import React from 'react';
import { useTheme } from '@/presentation/contexts/ThemeContext';
import { useLocale } from '@/presentation/contexts/LocaleContext';
import { useResponsiveDesign } from '@/presentation/responsiveDesign/responsiveDesign';
import {
  ExpauseButton,
  ButtonVariant,
  ButtonSize,
} from '@/presentation/components/common/controls/ExpauseButton';
import { qaAttr } from '@/presentation/utils/qaAttr';

export interface UserDetailsActionsProps {
  isCurrentUser: boolean;
  subscribeLabel: string;
  onSubscribePress: () => void;
  onCommunityPress: () => void;
  onSecondaryPress: () => void;
}

export const UserDetailsActions: React.FC<UserDetailsActionsProps> = ({
  isCurrentUser,
  subscribeLabel,
  onSubscribePress,
  onCommunityPress,
  onSecondaryPress,
}) => {
  const { theme } = useTheme();
  const { l10n } = useLocale();
  const responsive = useResponsiveDesign();

  return (
    <div className="flex items-center" style={{ gap: responsive.gap.base }}>
      <div style={{ flex: 1, minWidth: 0 }}>
        <ExpauseButton
          {...qaAttr({ id: 'user-details-subscribe' })}
          variant={!isCurrentUser ? ButtonVariant.primary : ButtonVariant.secondary}
          size={ButtonSize.large}
          onClick={onSubscribePress}
        >
          {subscribeLabel}
        </ExpauseButton>
      </div>

      <div style={{ flex: 1, minWidth: 0 }}>
        <ExpauseButton
          {...qaAttr({ id: 'user-details-action-community' })}
          variant={ButtonVariant.secondary}
          size={ButtonSize.large}
          onClick={onCommunityPress}
        >
          {l10n.common.community}
        </ExpauseButton>
      </div>

      <ExpauseButton
        {...qaAttr({ id: isCurrentUser ? 'user-details-action-premium' : 'user-details-message' })}
        variant={ButtonVariant.round}
        size={ButtonSize.small}
        backgroundColor={theme.transparent}
        icon={isCurrentUser ? '/assets/images/premium.png' : '/assets/images/chat.png'}
        iconColor={isCurrentUser ? theme.exclusive : theme.icon.secondary}
        iconSize={responsive.icon.xlarge}
        onClick={onSecondaryPress}
        aria-label={isCurrentUser ? l10n.common.premium : l10n.common.chat}
      />
    </div>
  );
};
